<div class="px-[16px] min-[991px]:px-[48px] !mt-[24px] min-[991px]:!mt-[52px] mb-[48px]">
  <h2 class="min-[991px]:mb-[16px] mb-[3px] text-[16px] min-[991px]:text-[32px] text-[#000] font-[500]">
    {{ titleKey | translate }}
  </h2>
  <p *ngIf="descriptionKey" class="text-[10px] min-[991px]:text-[20px] text-[#979797] font-[400]">
    {{ descriptionKey | translate }}
  </p>
</div>

<form
  class="px-[16px] min-[991px]:px-[48px] sign-up-form tax-setup-form mb-0 min-[991px]:pb-[24px]"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
>
  <div class="mb-[16px] min-[991px]:mb-[32px]">
    <mat-label class="block mb-[8px] min-[991px]:mb-[24px] text-[#000] text-[14px] min-[991px]:text-[24px] font-[500]">
      {{ 'DoYouHaveTax' | translate }}
    </mat-label>
    <mat-radio-group class="ms-[-11px] max-[991px]:flex max-[991px]:flex-col" formControlName="HaveTax" color="primary">
      <mat-radio-button [value]="true">{{ 'Yes' | translate }}</mat-radio-button>
      <mat-radio-button [value]="false" class="min-[991px]:ms-[8px]">{{ 'No' | translate }}</mat-radio-button>
    </mat-radio-group>
  </div>

  <div *ngIf="form.get('HaveTax')?.value === true" class="mb-0 min-[991px]:mb-[15px] tax-percentage-wrap">
    <mat-label class="block mb-[8px] min-[991px]:mb-[24px] text-[#000] text-[14px] min-[991px]:text-[24px] font-[500]">
      {{ 'Tax_Percentage' | translate }}
    </mat-label>
    <mat-form-field appearance="outline">
      <input
        matInput
        type="number"
        formControlName="TaxRate"
        placeholder="0"
        appNumberOnly
      />
      <span matSuffix><i class="fa-solid fa-percent" style="margin-inline-end: 10px;"></i></span>
      <mat-error>
        <app-error-form
          [name]="'Tax_Percentage' | translate"
          [control]="form.controls['TaxRate']"
          [max]="60"
          [min]="1"
        ></app-error-form>
      </mat-error>
    </mat-form-field>
  </div>

  <div class="field-group" *ngIf="form.get('HaveTax')?.value === true">
    <mat-label class="block mb-[8px] min-[991px]:mb-[24px] text-[#000] text-[14px] min-[991px]:text-[24px] font-[500]">
      {{ 'Price_include_taxes' | translate }}
    </mat-label>
    <mat-radio-group class="ms-[-11px] max-[991px]:flex max-[991px]:flex-col" formControlName="PriceIncludeTax" color="primary">
      <mat-radio-button [value]="true">{{ 'Yes' | translate }}</mat-radio-button>
      <mat-radio-button [value]="false" class="min-[991px]:ms-[8px]">{{ 'No' | translate }}</mat-radio-button>
    </mat-radio-group>
  </div>

  <div
    class="actions-buttons"
    *ngIf="showActions"
    fxLayout="row"
    fxLayoutAlign="stretch center"
  >
    <button
      type="button"
      class="action-btn prev-btn"
      fxFlex="1 1 0"
      (click)="onCancelClick()"
    >
      {{ cancelLabelKey | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      class="action-btn submit-btn"
      fxFlex="1 1 0"
      type="submit"
      [disabled]="!canConfirm || loading"
    >
      {{ submitLabelKey | translate }}
      <span class="btn-spinner-icon" *ngIf="loading"></span>
    </button>
  </div>
</form>
